import { css } from "@linaria/core";
import {
  makeSelectors,
  units,
  surfaces,
  breakpoints,
  outline,
  colors,
  easings,
  postloadedImageSelectors,
} from "@pm2/compat";

export const crossFadeDurationMs = 200;

export const modifiers = makeSelectors({
  isPlaying: css``,
});

export const wrapper = css`
  position: relative;

  height: ${units.px(150)};
  width: ${units.px(150)};

  background: ${surfaces.accent()};
  border-radius: ${units.px(4)};

  overflow: hidden;

  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;

  transition: background-color 0.2s linear, color 0.2s linear;

  &[data-disabled="true"] {
    pointer-events: none;
  }

  &[data-error="true"] {
    background: ${surfaces.gray.sim06()};
  }

  @media ${breakpoints.mobile.andDown().toQuery()} {
    height: ${units.px(100)};
    width: ${units.px(100)};
  }
`;

export const imageWrapper = css`
  position: absolute;
  inset: 0;
  z-index: 1;

  &::before {
    content: "";

    position: absolute;
    inset: 0;
    z-index: 2;

    background-color: rgba(0 0 0 / 0.2);
  }

  & ${postloadedImageSelectors.wrapper()} {
    position: relative;
    z-index: 1;

    height: 100%;
    width: 100%;
  }

  & ${postloadedImageSelectors.image()} {
    object-fit: cover;
  }
`;

export const button = css`
  ${outline({ borderRadius: "50%", offset: units.px(6) })};

  position: relative;
  z-index: 2;

  height: ${units.px(80)};
  width: ${units.px(80)};

  background-color: ${surfaces.accent.default.color({ alpha: 0.2 })};
  border: ${colors.gray.sim10({ alpha: 0 })} solid ${units.px(2)};
  border-radius: 50%;

  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;

  transition: background-color linear 100ms, color linear 100ms,
    box-shadow linear 100ms, border linear ${crossFadeDurationMs}ms,
    transform ${easings.outQuad} 150ms;

  &:hover {
    transform: scale(1.1);
  }

  ${colors.selectors.accent.isLight()} & {
    background-color: ${surfaces.accent.default.color({ alpha: 0.1 })};
  }

  .${wrapper}[data-error="true"] &&,
  .${wrapper}[data-with-image="true"] && {
    background-color: rgba(255 255 255 / 0.4);
    color: #fff;
  }

  .${wrapper}[data-error="true"] && {
    color: ${colors.text.primary()};
  }

  @media ${breakpoints.mobile.andDown().toQuery()} {
    height: ${units.px(50)};
    width: ${units.px(50)};
  }
`;

export const icon = css`
  height: 100%;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  & svg[data-type="play"] {
    margin-left: ${units.px(8)};

    fill: none;
    stroke: currentColor;

    @media ${breakpoints.mobile.andDown().toQuery()} {
      margin-left: ${units.px(5)};
    }
  }

  & svg[data-type="alert"] {
    margin-top: ${units.px(-5)};

    @media ${breakpoints.mobile.andDown().toQuery()} {
      margin-top: ${units.px(-3)};
    }
  }

  &-enter {
    opacity: 0;
    transform: scale(0.5);

    &-active {
      opacity: 1;
      transform: scale(1);
      transition: opacity ${crossFadeDurationMs}ms linear,
        transform ${crossFadeDurationMs}ms ${easings.outQuad};
    }
  }

  &-exit {
    position: absolute;
    top: 50%;
    left: 50%;

    opacity: 1;
    transform: translate(-50%, -50%) scale(1);

    &-active {
      opacity: 0;
      transform: translate(-50%, -50%) scale(0.5);
      transition: opacity ${crossFadeDurationMs}ms linear,
        transform ${crossFadeDurationMs}ms ${easings.inQuad};
    }
  }
`;

export const asyncProgressCircle = css`
  position: absolute;
  inset: ${units.px(-4)};

  height: ${units.px(84)};
  width: ${units.px(84)};

  fill: none;
  stroke: currentColor;
  stroke-width: ${units.px(4)};

  &-enter {
    opacity: 0;

    &-active {
      opacity: 1;
      transition: opacity ${crossFadeDurationMs}ms linear;
    }
  }

  &-exit {
    opacity: 1;

    &-active {
      opacity: 0;
      transition: opacity ${crossFadeDurationMs}ms linear;
    }
  }
`;
